import VbdGlobalView from '../components/volume-based-discounts/vbd-global-view';
import { DynamicDrawerProvider } from '../context/dynamic-drawer.context';

const VolumeBasedDiscounts = (): JSX.Element => (
  <DynamicDrawerProvider>
    <VbdGlobalView />
  </DynamicDrawerProvider>
);

export default VolumeBasedDiscounts;
